import type { ColumnDef } from "@tanstack/react-table";

import type { DriverRow } from "@/types/driver";
import ColumnHeader from "@/ui/ColumnHeader";
import type { DataTableFeatures } from "@/ui/dataTableFeatures";
import type { ColumnFilterOptions } from ".";
import { columnWidthFloors } from "./columnMinWidth";
import { formatDutyStatusLabel } from "./dutyStatusFormat";

function DutyStatusCell({ driver }: { driver: DriverRow }) {
  const label = formatDutyStatusLabel(driver.mostRecentDutyStatusStatus);
  if (!label) return <>—</>;
  return <>{label}</>;
}

const DUTY_STATUS_COLUMN_TITLE = "Duty Status";

export function dutyStatusColumn(options: ColumnFilterOptions): ColumnDef<DataTableFeatures, DriverRow> {
  const { minSize, initialMinWidth } = columnWidthFloors(DUTY_STATUS_COLUMN_TITLE, {
    draggable: true,
    hasFilter: true,
  });
  return {
    accessorFn: (row) => row.mostRecentDutyStatusStatus ?? "",
    id: "dutyStatus",
    header: () => (
      <ColumnHeader
        title={DUTY_STATUS_COLUMN_TITLE}
        extra={options.getColumnExtra("dutyStatus")}
        isActive={options.isFilterActive("dutyStatus")}
      />
    ),
    cell: ({ row }) => <DutyStatusCell driver={row.original} />,
    meta: { flex: 1.5, draggable: true, initialMinWidth },
    minSize,
    enableSorting: false,
    enableGlobalFilter: false,
  };
}
